import {
  CarouselControls,
  CarouselNavigation,
  CarouselPagination,
  CarouselSlide,
  Carousel as DSCarousel,
} from '@cinch-labs/design-system'
import type { Vehicle } from '@cinch-nx/shared-types'
import cx from 'classnames'

import styles from './carousel.module.css'
import { VehicleCard, VehicleCardV2 } from '@cinch-nx/landing-ui-shared'
import { readFromEnv, Env } from '@cinch-nx/environments'

interface CarouselProps {
  carouselName: string
  vehicles: Vehicle[]
}

const showVehicleCardV2 = readFromEnv(Env.VehicleCardV2) === 'true'

export const Carousel = ({ carouselName, vehicles }: CarouselProps) => {
  const navAriaLabels = {
    previous: 'Go to previous slide',
    next: 'Go to next slide',
  }

  return (
    <>
      <DSCarousel
        name={carouselName}
        swiperSettings={{
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            564: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        }}
        ariaLabel={`${carouselName}-carousel`}
      >
        {vehicles.map((vehicle) => (
          <CarouselSlide key={vehicle.vehicleId}>
            {showVehicleCardV2 ? (
              <VehicleCardV2 vehicle={vehicle} />
            ) : (
              <VehicleCard
                vehicle={vehicle}
                id={'electric-cars-carousel'}
                isSaved={false}
                isPending={false}
                isAvailable={vehicle.isAvailable}
              />
            )}
          </CarouselSlide>
        ))}
      </DSCarousel>
      <CarouselControls customClassNames={styles.controlsWrapper}>
        <CarouselPagination
          name={carouselName}
          customClassNames={cx(
            `${carouselName}-pagination`,
            styles.pagination,
            styles.customPagination,
          )}
          data-testid="ds-carousel-pagination"
          aria-hidden="true"
        />
        <CarouselNavigation
          name={carouselName}
          ariaLabels={navAriaLabels}
          aria-hidden={true}
          customClassNames={{
            prevButton: styles.prevButton,
            nextButton: styles.nextButton,
          }}
        />
      </CarouselControls>
    </>
  )
}
